import styled from '@emotion/styled';

const StyledButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--dk-bg-strong, #e7e9ec);
`;

const FileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 16px 16px 16px;
`;

const FileContainer = styled.div`
  display: flex;
  border: 4px;
  padding: 4px 8px 4px 4px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: content-box;
  border-radius: 4px;
`;

const Container = styled.div`
  border-radius: 6px;
  border: 1px solid black;
  padding: 10px 16px 10px 12px;
  position: relative;
  box-shadow: 0 0 4px 0 rgba(0, 102, 204, 0.25);
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  :disabled {
    background-color: var(--dk-bg-strong, #e7e9ec);
  }
`;

const StyledTitle = styled.div`
  overflow: hidden;
  color: var(--dk-text-dim, #b7bbc2);
  text-overflow: ellipsis;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 200% */
`;

const StyledSubTitle = styled.div`
  overflow: hidden;
  color: var(--dk-text-secondary, #888d96);
  text-overflow: ellipsis;
  /* System/Caption/KORENG/12 Regular */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
`;

export {
  StyledTitle,
  StyledSubTitle,
  StyledButtonsContainer,
  Divider,
  FileWrapper,
  FileContainer,
  Container,
  Wrapper,
  StyledButton,
};
